import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react'

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	height: "25px",
	width: "125px",
	textTransform: "capitalize",
	marginLeft:2,
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const ConfirmReject = (props) => {
    const { confirmDialog } = props;
  return (
    <Dialog open={confirmDialog.isOpen} PaperProps={{ sx: { position: "fixed", top: 100 } }}>
        <DialogTitle>
            <Typography component="h2" variant="subtitle1" gutterBottom>
                {confirmDialog.title}
            </Typography>
        </DialogTitle>
        <DialogContent>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {confirmDialog.question}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button
                variant="extended"
                sx={styleButton}
                onClick={confirmDialog.onConfirm}
            >
                Confirm
            </Button>
            <Button
                variant="extended"
                sx={styleButton}
                onClick={confirmDialog.onReject}
            >
                Cancel
            </Button>
        </DialogActions>
    </Dialog>
  )
}

export default ConfirmReject